import styled from 'styled-components';
import { animated } from 'react-spring';
import { device } from '../../styles/devices';
import { COLORS } from '../../styles/variables';

export const FilterMenu = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  right: 0;
  z-index: 110;

  @media ${device.tablet} {
    position: absolute;
  }
  @media ${device.laptop} {
    position: inherit;
    width: 414px;
  }
`;

export const FilterDrawerMobile = styled(animated.div)`
  position: fixed;
  background: rgba(0, 0, 0, 0.75);
  /* position: fixed; */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 200;
  overflow-y: auto;
`;
export const FiltersContainer = styled(animated.div)`
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  overflow-y: auto;
`;

export const FilterDrawerWrapper = styled(animated.div)`
  height: 100vh;
  overflow-y: auto;
  position: fixed;
  width: 100%;
  right: 0;
  z-index: 99;
  inset: 0px;
  @media ${device.laptop} {
    position: sticky;
    width: auto;
    top: -1px;
  }
`;

export const AnimatedFilterBar = animated(FilterDrawerWrapper);

export const BlackBackground = styled(animated.div)`
  background: ${COLORS.black};
  opacity: 0.75;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
`;

export const FiltersWrapper = styled.div`
  width: 100%;
  background-color: ${COLORS.white};
  position: relative;
  @media ${device.tablet} {
    width: 374px;
  }
  @media ${device.laptopMd} {
    width: 100%;
  }
`;

export const FilterHeadWrapper = styled.div`
  padding: 20px 24px 16px 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  position: sticky;
  width: auto;
  height: auto;
  top: 0;
  background: ${COLORS.white};
  z-index: 100;
  /* width: 360px; */
  box-shadow:
    0px 6px 6px -6px rgba(0, 0, 0, 0.2),
    0px 3px 4px -3px rgba(0, 0, 0, 0.1);

  @media ${device.laptop} {
    padding: 20px 24px 20px 48px;
    position: initial;
    box-shadow: none;
    width: auto;
    border-bottom: 1px solid ${COLORS.grey15};
  }
`;

export const TitleAndClose = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ExpandFilters = styled.button`
  border: none;
  background: initial;
  font-family: Audi Type;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.002px;
  color: ${COLORS.grey60};
  padding: 0;
  margin-top: 8px;
  border-bottom: 1px solid ${COLORS.grey60};
  cursor: pointer;
`;

export const FiltersList = styled.div<{ isReachedEndOfContainer: boolean; isPassedNav: boolean }>`
  padding: 0 12px 12px 12px;
  @media ${device.laptopMd} {
    padding: 0 24px 24px 24px;
    padding-bottom: ${({ isReachedEndOfContainer }) => (isReachedEndOfContainer ? '24px' : '24px')};
    margin-bottom: ${({ isPassedNav }) => (isPassedNav ? 0 : '78px')};
  }
`;

export const HideFilters = styled.button`
  border: none;
  background: initial;
  font-family: Audi Type;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.002px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  cursor: pointer;
`;

export const Title = styled.h2`
  font-family: Audi Type;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0.002px;
`;

export const Filter = styled.div<{ showFilter?: boolean }>`
  border-bottom: 1px solid ${COLORS.grey15};
`;

export const ExposedButton = styled.div`
  padding: 16px;
  /* border-bottom: 1px solid ${COLORS.grey15}; */
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
`;

export const FilterHeader = styled.div`
  width: 100%;
`;

export const FilterTitle = styled.div`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${COLORS.grey80};
  font-family: Audi Type;
  position: relative;
  display: flex;
  flex-direction: row;
`;

export const FilterListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.002px;
  color: ${COLORS.grey60};
`;

export const GreenDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${COLORS.spaceInvader};
  margin-top: 6px;
`;

export const FilterList = styled.div`
  max-width: 93%;
`;

export const FilterSelection = styled(animated.div)<{ setPaddings?: boolean }>`
  background-color: rgba(0, 0, 0, 0.05);
  padding: ${({ setPaddings }) => setPaddings && '24px'};
`;

export const FilterFrame = styled(animated.div)`
  padding: 16px;
`;

export const Disclaimer = styled.div`
  padding-bottom: 12px;
`;

export const GroupWrapper = styled.div<{ fullWidth?: boolean }>`
  display: grid;
  grid-template-columns: ${({ fullWidth }) => (fullWidth ? 'none' : 'repeat(2, 1fr)')};
  row-gap: 24px;
`;

export const CTAsWrapper = styled(animated.div)<{ $isReachedEndOfContainer: boolean }>`
  left: 12px;
  right: 12px;
  position: sticky;
  bottom: 0;
  padding-top: 16px;
  padding-bottom: 24px;
  background-color: ${COLORS.white};
  @media ${device.tablet} {
    left: auto;
    right: auto;
    width: auto;
  }
  @media ${device.laptop} {
    position: ${({ $isReachedEndOfContainer }) => (!$isReachedEndOfContainer ? 'fixed' : 'sticky')};
  }
`;

export const GroupOfCTAs = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: ${COLORS.white};
`;

export const ShowResultsCTA = styled.button<{ isZeroResults: boolean }>`
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: ${({ isZeroResults }) => (isZeroResults ? COLORS.grey30 : COLORS.black)};
  color: ${COLORS.white};
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  cursor: ${({ isZeroResults }) => !isZeroResults && 'pointer'};

  @media ${device.tablet} {
    width: 351px;
  }

  @media ${device.laptop} {
    width: 366px;
  }
`;

export const ResetFilters = styled.button<{ isLoading: boolean }>`
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: ${COLORS.white};
  color: ${({ isLoading }) => (isLoading ? COLORS.grey30 : COLORS.black)};
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  cursor: pointer;
  border: ${({ isLoading }) =>
    isLoading ? `1px solid ${COLORS.grey30}` : `1px solid ${COLORS.black}`};

  @media ${device.tablet} {
    width: 351px;
  }
  @media ${device.laptop} {
    width: 366px;
  }
`;

export const IconWrapper = styled.div<{ setLeftMargin?: boolean }>`
  cursor: pointer;
  margin-left: ${({ setLeftMargin }) => setLeftMargin && '8px'};
`;
